<template>
  <div
    class="contact-field-wrapper relative flex items-center space-x-2"
    data-cy="contact"
  >
    <div
      v-if="isLendflowUser"
      v-tooltip="$t('COMMON.REPLY')"
      data-cy="reply-button"
      class="icon flex h-[26px] w-[26px] cursor-pointer items-center justify-center rounded-full hover:bg-disabled"
      @click.stop="handleShowEmail"
    >
      <icon-base :icon="IconReply" />
    </div>
    <send-deal-communication-modal
      v-if="showEmailModal"
      :deal-id="data.dealId"
      :deal-name="data.name || ''"
      @close-dialog="showEmailModal = false"
    >
      <template #content>
        <email-form
          :data="{ subject: data.subject, to: data.to }"
          class="h-[calc(100%-48px)]"
          @email:reply="replyToEmail"
        />
      </template>
    </send-deal-communication-modal>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";

import { EMAIL_UPDATED } from "@/helpers/constants/events";
import { useAuth } from "@/hooks/auth";
import { useEmitter, usePromiseWrapper } from "@/hooks/common";
import emailService from "@/services/modules/emails";

import SendDealCommunicationModal from "@/components/communication/SendDealCommunicationModal.vue";
import EmailForm from "@/components/communicationLogs/communication/emailThread/EmailForm.vue";
import IconReply from "@/components/icons/IconReply.vue";
import IconBase from "@/components/ui/IconBase.vue";

interface Props {
  data: {
    emailId: number;
    dealId: string;
    name: string | undefined;
    subject: string;
    to: string;
  };
}

const props = defineProps<Props>();

const { isLendflowUser } = useAuth();
const emitter = useEmitter();

const showEmailModal = ref(false);

const handleShowEmail = () => {
  showEmailModal.value = true;
};

const { fetchWrapper: replyToEmail } = usePromiseWrapper(
  async (body: string, files: File[]) => {
    await emailService.replyToEmail({
      emailId: props.data.emailId,
      body,
      files,
    });
    showEmailModal.value = false;
    emitter.emit(EMAIL_UPDATED);
  }
);
</script>

<style scoped>
@reference "@/assets/tailwind.css";

:deep(.icon svg:not(.absolute)) {
  @apply m-auto flex;
}
</style>
